import './Messenger.scss';
import { ChannelsNames } from '../Channels';
import { MessengerConstants } from './MessengerConstants';
// Controllers
import { ChannelBaseController } from '../ChannelBaseController';
import { MessengerDisconnectModalController } from './modals/MessengerDisconnectModalController';
// Events
import { CHANNEL_CONNECTION_MESSENGER_OVERVIEW_CLICKED, CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CLICKED, CHANNEL_CONNECTION_MESSENGER_CUSTOMER_CHAT_PLUGIN_CLICKED, CHANNEL_CONNECTION_MESSENGER_CUSTOMER_CHAT_PLUGIN_SAVED_DOMAIN, CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CUSTOM_APPLICATION_SAVED, CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_APPLICATION, CHANNEL_CONNECTION_MESSENGER_FACEBOOK_LOGIN_EMBEDDED, CHANNEL_CONNECTION_MESSENGER_CONNECTION_SUCESSFUL, CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_COPIED_HTML, CHANNEL_START_DISCONNECTION_MESSENGER, CHANNEL_DISCONNECTION_MESSENGER, CHANNEL_MESSENGER_LOGGEDOUT_FACEBOOK, CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CHOSED_CONNECTION_TYPE, CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CREATE_PAGE_CLICKED, CHANNEL_CONNECTION_MESSENGER_OVERVIEW_CREATE_PAGE_CLICKED, } from '../ChannelsSegmentEvents';
// Views
import '!ng-cache-loader!./MessengerLostDataAlert.html';
import '!ng-cache-loader!./MessengerPageInUseAlert.html';
import '!ng-cache-loader!./MessengerDisconnectAlert.html';
import '!ng-cache-loader!./messengerTabs/MessengerOverviewTab.html';
import '!ng-cache-loader!./messengerTabs/MessengerCustomerChatTab.html';
import '!ng-cache-loader!./messengerTabs/MessengerConfigurationsTab.html';
// Modals
import MessengerDisconnectModal from './modals/MessengerDisconnectModalView.html';
export const FB_ACCESS_TOKEN = MessengerConstants.FB_ACCESS_TOKEN;
export class MessengerControllerDpr extends ChannelBaseController {
    static $inject = ['application', 'ApplicationService2', 'ChannelsService', 'BlipToastService', 'ChannelsSegmentService', 'FacebookService', 'LoadingService', 'MessengerService', 'PermissionsService', 'SegmentService', '$q', '$translate', 'MESSENGER_AUTH_PERMISSIONS', '$cookies', 'ModalService', '$timeout', 'FacebookLoginPopupService', 'FACEBOOK_POPUP_CONNECTION_TIME'];
    handlefbAuthorize() { }
    constructor(application, ApplicationService2, ChannelsService, BlipToastService, ChannelsSegmentService, FacebookService, LoadingService, MessengerService, PermissionsService, SegmentService, $q, $translate, MESSENGER_AUTH_PERMISSIONS, $cookies, ModalService, $timeout, FacebookLoginPopupService, FACEBOOK_POPUP_CONNECTION_TIME) {
        'ngInject';
        super(ChannelsNames.Messenger, ChannelsService, ApplicationService2, application);
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.ChannelsService = ChannelsService;
        this.BlipToastService = BlipToastService;
        this.ChannelsSegmentService = ChannelsSegmentService;
        this.FacebookService = FacebookService;
        this.LoadingService = LoadingService;
        this.MessengerService = MessengerService;
        this.PermissionsService = PermissionsService;
        this.SegmentService = SegmentService;
        this.$q = $q;
        this.$translate = $translate;
        this.MESSENGER_AUTH_PERMISSIONS = MESSENGER_AUTH_PERMISSIONS;
        this.$cookies = $cookies;
        this.ModalService = ModalService;
        this.$timeout = $timeout;
        this.FacebookLoginPopupService = FacebookLoginPopupService;
        this.FACEBOOK_POPUP_CONNECTION_TIME = FACEBOOK_POPUP_CONNECTION_TIME;
        this.facebookPageSelected = false;
        this.messengerConfigurationsChosedNativeConnection = true;
        this.onApplicationIdInput = (event) => {
            this.applicationId = event.detail.value;
        };
        this.onApplicationSecretInput = (event) => {
            this.applicationSecret = event.detail.value;
        };
        this.onSelectFacebookPage = () => {
            this.facebookPageSelected = true;
        };
        this.connectPage = async () => {
            const selectOptionElement = document.getElementById('selectFacebookPages');
            const pageId = selectOptionElement.value;
            const page = this.facebookPages.find(p => p.id === pageId);
            this.facebookPageSelected = false;
            const picture = await this.FacebookService.getPagePicture(page.id, this.accessToken);
            this.alienPage = {
                id: page.id,
                name: page.name,
                picture: picture,
            };
            this.channel.configurations.PageId = page.id;
            this.channel.configurations.UserAccessToken =
                page.access_token ||
                    this.channel.configurations.UserAccessToken;
            this.channel.configurations.UserId = this.facebookUser.id;
            this.isActive = true;
            this.channel.configurations.PageAccessTokenExpiredReason = undefined;
            this.saveConnection(page);
        };
        this.modalBackButtonCallback = (page) => {
            this.updateConnectedPages(page, true);
        };
        this.disconnectPage = async (page, disconnectionMotive, button) => {
            this.tryAddKeepconfigurations();
            if (this.keepConfigurations.length > 0) {
                this.keepConfigurations.push('IsChannelActive');
                this.channel.configurations.KeepConfigurations = this.keepConfigurations;
            }
            else {
                this.channel.configurations.KeepConfigurations = ['IsChannelActive'];
            }
            this.cleanPageAndUserConfigurations();
            this.isActive = false;
            this.channel.configurations.PageAccessTokenExpiredReason = undefined;
            await this.saveConnection(page, true, button, disconnectionMotive);
        };
        this.saveConnection = async (page, showSuccessToast = true, button = 'page', disconnectionMotive = undefined) => {
            this.LoadingService.startLoading();
            try {
                await this.updateChannel();
                this.isNew = false;
                if (showSuccessToast) {
                    this.BlipToastService.show('success', {
                        title: await this.$translate('messenger.successMsg.title.2'),
                        msg: await this.$translate('messenger.successMsg.msg.2'),
                    });
                }
                this.updateConnectedPages(page);
                if (this.isActive) {
                    this.trackChannelConnectionMessengerConnectionSuccessful(true);
                }
                else {
                    this.trackChannelDisconnectionMessenger(true, button, disconnectionMotive);
                }
            }
            catch (err) {
                this.isActive = !this.isActive;
                if (err.code == 67 && err.description == 'This gateway is already deactivated') {
                    if (showSuccessToast) {
                        this.BlipToastService.show('success', {
                            title: await this.$translate('messenger.successMsg.title.2'),
                            msg: await this.$translate('messenger.successMsg.msg.2'),
                        });
                    }
                }
                else if (err.code == 64) {
                    this.handleAlreadyPublishedPage();
                }
                else {
                    this.BlipToastService.show('danger', {
                        msg: await this.$translate('utils.errorMsg.4'),
                    });
                }
                if (this.isActive) {
                    this.trackChannelConnectionMessengerConnectionSuccessful(false, err);
                }
                else {
                    this.trackChannelDisconnectionMessenger(false, button, disconnectionMotive, err);
                }
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.updateConnectedPages = (page, fromCallback = false) => {
            const facebookPagesAux = this.facebookPages.map(facebookPage => {
                if (facebookPage.id === page.id) {
                    if (fromCallback) {
                        const switchItems = document.getElementsByName(page.id);
                        if (switchItems && switchItems.length > 0) {
                            switchItems[0].checked = true;
                        }
                    }
                }
                return facebookPage;
            });
            this.$timeout(() => {
                this.facebookPages = facebookPagesAux;
            });
        };
        this.onDisconnectPage = async () => {
            const page = this.facebookPages.find(p => p.id === this.getActivePageId());
            await this.openModalDisconnectAsync(page, 'page');
        };
        this.transformDomain = async (event) => {
            if (this.domains?.join(',') !== event.detail.data?.join(',')) {
                this.domains = event.detail.data;
                this.domains = this.domains.map(value => {
                    if (value.indexOf('://') > -1) {
                        return value.split('/')[2];
                    }
                    else {
                        return value.split('/')[0];
                    }
                });
            }
        };
        this.onClickConfigurationsChosedConnectionType = (event) => {
            if (event.detail?.checked) {
                if (event.target?.id == 'native') {
                    this.messengerConfigurationsChosedNativeConnection = true;
                    this.trackChannelMessengerConfigurationsChosedConnectionType('native');
                }
                else if (event.target?.id == 'custom') {
                    this.messengerConfigurationsChosedNativeConnection = false;
                    this.trackChannelMessengerConfigurationsChosedConnectionType('custom');
                }
            }
        };
        if (this.isNew) {
            this.isActive = false;
        }
        // Guard to avoid runtime errors if DI fails unexpectedly (defensive; should be defined now)
        if (this.LoadingService && typeof this.LoadingService.startLoading === 'function') {
            this.LoadingService.startLoading();
        }
        this._init();
        this.handlefbAuthorize = this.fbAuthorize.bind(this);
        this.onConfigureAppClick = this.onConfigureAppClick.bind(this);
        this.resetSettingsData = this.resetSettingsData.bind(this);
    }
    async _init() {
        this.application.channels = await this.ChannelsService.getChannel(ChannelsNames.Messenger, this.isConfigurationsApplicationsDomainUsageGetEnabled);
        this.ChannelsSegmentService.setApplication(this.application);
        this.hasPermission = await this.PermissionsService.hasPermissions('write');
        this.subsidiary = await this.ChannelsService.getSubsidiary(ChannelsNames.Messenger);
        const { AppId, GraphApiVersion } = await this.loadApplicationInformation();
        this.graphApiVersion = GraphApiVersion;
        this.nativeAppId = AppId;
        await this.getWhitelistedDomains();
        this._loadFacebookUser();
    }
    async getWhitelistedDomains() {
        try {
            const result = await this.MessengerService.getwhiteListedDomains(this.application);
            this.domains = result ? result.items.map((x) => x.uri) : [];
            return this.domains;
        }
        catch (err) {
            console.error(err);
            return [];
        }
    }
    chanelHasConfiguration() {
        return this.channel &&
            Object.keys(this.channel.configurations).length >= 1 &&
            this.channel.configurations.IsChannelActive != 'False';
    }
    async onConfigureAppClick() {
        if ((this.applicationId === undefined || this.applicationId === '') ||
            (this.applicationSecret === undefined || this.applicationSecret === '')) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('messenger.errorMsg.title.1'),
                msg: await this.$translate('messenger.errorMsg.msg.2'),
            });
            return;
        }
        try {
            await this.MessengerService.validateApplicationInfo({
                id: this.applicationId,
                secret: this.applicationSecret,
            });
            this.customApplicationLastStep = true;
            this.channel.configurations.AppId = this.applicationId;
            this.channel.configurations.AppSecret = this.applicationSecret;
            this.trackChannelConnectionMessengerConfigurationsCustomApplicationSaved(true);
        }
        catch (error) {
            this.BlipToastService.show('danger', {
                title: await this.$translate('messenger.errorMsg.title.1'),
                msg: await this.$translate('messenger.errorMsg.msg.1'),
            });
            this.trackChannelConnectionMessengerConfigurationsCustomApplicationSaved(false, error);
        }
    }
    async toggleLostDataAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=messenger-lost-data]');
        await bdsAlert.toggle();
    }
    async togglePageInUseAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=messenger-page-in-use]');
        await bdsAlert.toggle();
    }
    async toggleDisconnectAlert() {
        const bdsAlert = document.querySelector('bds-alert[id=messenger-disconnect-application]');
        await bdsAlert.toggle();
    }
    async resetSettingsData(resetConfigurationData = false) {
        this.customApplicationLastStep = false;
        this.applicationId = undefined;
        this.applicationSecret = undefined;
        this.applicationType = undefined;
        if (resetConfigurationData) {
            this.channel.configurations.AppId = undefined;
            this.channel.configurations.AppSecret = undefined;
        }
    }
    async onFacebookLogin(user) {
        const permissions = await this.FacebookService.getUserPermissions(this.accessToken);
        const requiredPermissions = [
            'public_profile',
            'pages_manage_metadata',
            'pages_show_list',
            'pages_messaging',
        ];
        const hasRequiredPermissions = requiredPermissions.every(r => permissions.some((p) => p.permission === r && p.status === 'granted'));
        if (hasRequiredPermissions) {
            this.facebookPages = undefined;
            this.facebookPagesSelect = undefined;
            this.facebookUser = user;
            await this.loadAlienPage();
            return this.loadFacebookPages();
        }
        else {
            return this.$q.reject();
        }
    }
    async onFacebookLogout() {
        this.facebookUser = undefined;
        this.accessToken = undefined;
        this.facebookPages = undefined;
        this.facebookPagesSelect = undefined;
        localStorage.removeItem(FB_ACCESS_TOKEN);
    }
    async loadMoreFacebookPages() {
        if (!this.canLoadMore || this.isLoading()) {
            return;
        }
        this.loadFacebookPages();
    }
    disableLoader() {
        return !this.canLoadMore;
    }
    async loadFacebookPages() {
        this.LoadingService.startLoading();
        const queryLimit = 2000;
        try {
            const accounts = await this.FacebookService.getUserAccounts(queryLimit, undefined, this.accessToken);
            if (accounts.data.length < queryLimit) {
                this.canLoadMore = false;
            }
            else {
                this.canLoadMore = true;
            }
            if (accounts.data.length != 0) {
                const newFacebookPages = accounts.data;
                if (this.facebookPages == undefined) {
                    this.facebookPages = newFacebookPages;
                }
                else {
                    this.facebookPages = this.facebookPages.concat(newFacebookPages);
                }
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.facebookPagesSelect = this.facebookPages
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(c => ({
                value: c.id,
                label: c.name,
            }));
            this.LoadingService.stopLoading();
        }
    }
    async loadAlienPage() {
        const pageConfigurations = this.channel.configurations;
        const pageAccessToken = pageConfigurations.PageAccessToken ||
            pageConfigurations.UserAccessToken;
        if (pageAccessToken) {
            try {
                this.alienPage = await this.FacebookService.me(pageAccessToken);
            }
            catch (e) {
                this.alienPage = {
                    id: pageConfigurations.PageId,
                    name: '',
                };
            }
        }
    }
    tryAddKeepconfigurations() {
        if (this.keepConfigurations?.length > 0) {
            this.channel.configurations.KeepConfigurations = this.keepConfigurations;
        }
        else {
            this.keepConfigurations = ['AppId', 'AppSecret'];
        }
    }
    async handleAlreadyPublishedPage() {
        this.cleanPageAndUserConfigurations();
        this.alienPage = undefined;
        this.togglePageInUseAlert();
    }
    async openModalDisconnectAsync(page, button) {
        this.trackChannelStartDisconnectionMessenger(button);
        await this.ModalService.showModal({
            template: MessengerDisconnectModal,
            controller: MessengerDisconnectModalController,
            controllerAs: '$ctrl',
            inputs: {
                disconnectPage: this.disconnectPage.bind(this),
                button: button,
                page: page,
                backButtonCallback: this.modalBackButtonCallback.bind(this),
            },
        });
    }
    async saveWhitelist() {
        this.LoadingService.startLoading();
        try {
            if (this.domains.length === 0) {
                await this.MessengerService.deletewhiteListedDomains(this.application);
            }
            else {
                await this.MessengerService.savewhiteListedDomains(this.application, this.domains.map(x => ({ uri: x })));
            }
            const successMsg27 = await this.$translate('utils.successMsg.27');
            this.BlipToastService.show('success', {
                msg: successMsg27,
            });
            this.trackChannelConnectionMessengerCustomerChatPluginSavedDomain(this.domains, true);
        }
        catch (e) {
            const errorMsg106 = await this.$translate('utils.errorMsg.106');
            this.BlipToastService.show('danger', {
                msg: errorMsg106,
            });
            this.trackChannelConnectionMessengerCustomerChatPluginSavedDomain(this.domains, false, e);
            throw e;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async _loadFacebookUser() {
        this.LoadingService.startLoading();
        this.accessToken = localStorage.getItem(FB_ACCESS_TOKEN);
        if (this.accessToken) {
            try {
                this.accessToken = atob(this.accessToken);
                const user = await this.FacebookService.me(this.accessToken);
                this.onFacebookLogin(user);
            }
            catch {
                this.facebookUser = undefined;
            }
        }
        else {
            this.facebookUser = undefined;
        }
        this.LoadingService.stopLoading();
    }
    openLoginPopup() {
        const appId = this.getAppId();
        this.trackChannelConnectionMessengerConfigurationsApplication();
        clearInterval(this.timerId);
        let tab;
        [this.state, tab] = this.FacebookLoginPopupService.openFacebookLoginPopup(appId, this.graphApiVersion, this.MESSENGER_AUTH_PERMISSIONS);
        const timeToStopPoolingFacebookCookie = new Date(new Date().getTime() + this.FACEBOOK_POPUP_CONNECTION_TIME);
        this.timerId = setInterval(() => {
            if (this.$cookies.getObject(this.state)) {
                clearInterval(this.timerId);
                this.handlefbAuthorize();
                return;
            }
            if (new Date() > timeToStopPoolingFacebookCookie || tab.closed) {
                clearInterval(this.timerId);
            }
        }, 2000);
    }
    async fbAuthorize() {
        const { accessToken, state } = this.$cookies.getObject(this.state);
        if (state !== this.state) {
            return;
        }
        this.LoadingService.startLoading();
        try {
            const user = await this.FacebookService.me(accessToken);
            localStorage.setItem(FB_ACCESS_TOKEN, btoa(accessToken));
            this.accessToken = accessToken;
            await this.onFacebookLogin(user);
            if (this.applicationId && this.applicationSecret) {
                this.MessengerService.setConfiguration({
                    AppId: this.applicationId,
                    AppSecret: this.applicationSecret,
                }, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            }
            this.channel.configurations.IsChannelActive = 'True';
            this.resetSettingsData();
            this.trackChannelConnectionMessengerFacebookLoginEmbedded(true);
        }
        catch (e) {
            console.error(e);
            this.trackChannelConnectionMessengerFacebookLoginEmbedded(false, e);
        }
        finally {
            this.$cookies.remove(this.state);
            this.LoadingService.stopLoading();
        }
    }
    get activePageId() {
        return this.isActive ? this.channel.configurations.PageId : undefined;
    }
    set activePageId(page) {
        return;
    }
    get isLoading() {
        return this.LoadingService.isLoadingLocal;
    }
    get snippetSendToMessenger() {
        return `<div class='fb-send-to-messenger'
                    messenger_app_id="${this.nativeAppId}"
                    page_id="${this.activePageId}"
                    data-ref="<seu conteudo>"
                    color="blue"
                    size="standard">
                </div>`;
    }
    get snippetMessageUs() {
        return `<div class="fb-messengermessageus"
                    messenger_app_id="${this.nativeAppId}"
                    page_id="${this.activePageId}"
                    color="blue"
                    size="standard">
                </div>`;
    }
    // Segment
    trackConnectionMessengerConfigurationFacebookLoginClicked() {
        this.ChannelsSegmentService.trackConnectionMessengerConfigurationFacebookLoginClicked();
    }
    trackChannelConnectionMessengerOverviewClicked() {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_OVERVIEW_CLICKED);
    }
    trackChannelConnectionMessengerConfigurationsClicked() {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CLICKED);
    }
    trackChannelConnectionMessengerCustomerChatPluginClicked() {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CUSTOMER_CHAT_PLUGIN_CLICKED);
    }
    trackChannelConnectionMessengerCustomerChatPluginSavedDomain(domains, success, error) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CUSTOMER_CHAT_PLUGIN_SAVED_DOMAIN, {
            success,
            errorCode: this.getErrorCode(error),
            errorDescription: this.getErrorDescription(error),
            domains: domains.map(x => x.text).join(';'),
        });
    }
    trackChannelConnectionMessengerConfigurationsCustomApplicationSaved(success, error) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CUSTOM_APPLICATION_SAVED, {
            success,
            errorCode: this.getErrorCode(error),
            errorDescription: this.getErrorDescription(error),
        });
    }
    trackChannelConnectionMessengerConfigurationsApplication() {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_APPLICATION, { appId: this.getAppId() });
    }
    trackChannelConnectionMessengerFacebookLoginEmbedded(success, error) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_FACEBOOK_LOGIN_EMBEDDED, {
            success,
            errorCode: this.getErrorCode(error),
            errorDescription: this.getErrorDescription(error),
            appId: this.getAppId(),
        });
    }
    trackChannelConnectionMessengerConnectionSuccessful(success, error) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONNECTION_SUCESSFUL, {
            success,
            errorCode: this.getErrorCode(error),
            errorDescription: this.getErrorDescription(error),
        });
    }
    trackChannelConnectionMessengerConfigurationsCopiedHtml(htmlType) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_COPIED_HTML, { htmlType });
    }
    trackChannelStartDisconnectionMessenger(button) {
        this.trackApplicationEvent(CHANNEL_START_DISCONNECTION_MESSENGER, { button });
    }
    trackChannelDisconnectionMessenger(success, button, disconnectionMotive, error) {
        this.trackApplicationEvent(CHANNEL_DISCONNECTION_MESSENGER, {
            success,
            errorCode: this.getErrorCode(error),
            errorDescription: this.getErrorDescription(error),
            disconnectionMotive,
            button,
        });
    }
    trackChannelMessengerLoggedOutFacebook() {
        this.trackApplicationEvent(CHANNEL_MESSENGER_LOGGEDOUT_FACEBOOK);
    }
    trackChannelMessengerConfigurationsChosedConnectionType(connectionType) {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CHOSED_CONNECTION_TYPE, { connectionType });
    }
    trackChannelMessengerConfigurationsCreatePageClicked() {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_CONFIGURATIONS_CREATE_PAGE_CLICKED);
    }
    trackChannelMessengerOverviewCreatePageClicked() {
        this.trackApplicationEvent(CHANNEL_CONNECTION_MESSENGER_OVERVIEW_CREATE_PAGE_CLICKED);
    }
    async trackApplicationEvent(event, payload) {
        const application = this.application;
        await this.SegmentService.createApplicationTrack({
            trackEvent: event,
            application,
            payload: {
                isActive: this.isActive,
                activePageId: this.getActivePageId(),
                activePageName: this.getActivePageName(),
                ...payload,
            },
        });
    }
    channelIsActive() {
        return this.isActive;
    }
    getActivePageId() {
        const page = this.alienPage;
        if (!page) {
            return undefined;
        }
        return page.id;
    }
    getActivePageName() {
        const page = this.alienPage;
        if (!page) {
            return undefined;
        }
        return page.name;
    }
    getErrorCode(error) {
        if (!error) {
            return undefined;
        }
        return error.code;
    }
    getErrorDescription(error) {
        if (!error) {
            return undefined;
        }
        if (!error.description) {
            return error.toString();
        }
        return error.description;
    }
    getAppId() {
        return this.applicationId || this.channel.configurations.AppId || this.nativeAppId;
    }
    cleanPageAndUserConfigurations() {
        this.channel.configurations.PageId = undefined;
        this.channel.configurations.UserAccessToken = undefined;
        this.channel.configurations.PageAccessToken = undefined;
        this.channel.configurations.UserId = undefined;
    }
    async loadApplicationInformation() {
        const result = await this.ChannelsService.getFacebookAppInformation(ChannelsNames.Messenger, this.subsidiary);
        return result;
    }
}
MessengerControllerDpr.$inject = ['application', 'ApplicationService2', 'ChannelsService', 'BlipToastService', 'ChannelsSegmentService', 'FacebookService', 'LoadingService', 'MessengerService', 'PermissionsService', 'SegmentService', '$q', '$translate', 'MESSENGER_AUTH_PERMISSIONS', '$cookies', 'ModalService', '$timeout', 'FacebookLoginPopupService', 'FACEBOOK_POPUP_CONNECTION_TIME'];
